import React, {Component} from 'react'
import InputBarcode from "./InputBarcode"
import classNames from 'classnames'
import { notification, Spin } from 'antd'
import MergerSetDetail from './MergerSetDetail'
import { getBasketDetail } from '../../../services/api/mergerSetApi'


class MergerSetPage extends Component {
    interval = null;

    constructor(props) {
        super(props);
        this.notifRootRef = React.createRef();
        this.barcodeRef = React.createRef();
    }
    state = {
        barcode: '',
        loading: false,
        result: null,
        error: ''
    }

    _handleSubmit = (barcode) => {
        this.setState({
            barcode,
        }, () => this._submitBarcode())
    }

    _submitBarcode = async () => {
        const {barcode, loading} = this.state
        const vBarcode = barcode.replace(/#/gi, '')

        if (loading) return false

        this.setState({
            loading: true,
        })

        try {
            const {data} = await getBasketDetail(vBarcode)
            const {success, data: dataDetail, error} = {...data}
            
            if(!success) {
                this.stopAutoRefresh() //Khi lỗi → tắt interval
                return this.setState({
                    error: error,
                    loading: false,
                    // barcode: '',
                    result: null,
                })
            }

            this.setState({
                loading: false,
                result: dataDetail,
                error: '',
                // barcode: ''
            },() => {
                setTimeout(() => {
                    this.barcodeRef.current && this.barcodeRef.current._input.current && this.barcodeRef.current._input.current.focus()
                }, 100)
            })
            //Quét thành công → bật interval gọi _submitBarcode() mỗi 30s
            this.startAutoRefresh()
        } catch (e) {
            this.stopAutoRefresh()
            this.setState({
                error: e.message || e,
                loading: false,
                barcode: '',
                result: null,
            }, () => {
                setTimeout(() => {
                    this.barcodeRef.current && this.barcodeRef.current._input.current && this.barcodeRef.current._input.current.focus()
                }, 100)
            })
        }
    }

    startAutoRefresh = () => {
        if (this.interval) clearInterval(this.interval);

        this.interval = setInterval(() => {
            this._submitBarcode();
        }, 30000); // 30 giây
    }

    stopAutoRefresh = () => {
        if (this.interval) {
            clearInterval(this.interval);
            this.interval = null;
        }
    }

    _handleSetData = (data) => {
        this.setState({
            loading: false,
            result: data,
            error: '',
            barcode: ''
        })
    }

    _handleOnChange = value => {
        this.setState({
            barcode: value,
        })
    }

    _handleClose = (afterClose = null) => {
        this.stopAutoRefresh() //close item → tắt interval

        notification.destroy()
        this.setState({
            barcode: '',
            result: null,
            error: '',
        }, () => {
            typeof afterClose === 'function' && afterClose()
        })
    }

    _handleFocusInput = () => {
        this.barcodeRef.current && this.barcodeRef.current._input.current && this.barcodeRef.current._input.current.focus()
    }

    componentWillUnmount() {
        this.stopAutoRefresh() //rời page → tắt interval
    }

    render() {
        const {loading, barcode, result, error} = this.state

        return (
            <Spin spinning={loading} size="large">
                <div className={classNames("MergerPage", {loading})}>
                    <div id="notif-top-center-root" ref={this.notifRootRef} />
                    <div className='d-flex align-items-center justify-content-between'>
                        <h1>Gộp sản phẩm SET</h1>

                        <div className='listBtn'>
                            <a className="ant-btn mr-3 ant-btn-primary" href="/baskets-merge-set">Giỏ gộp SET</a>
                            <a className="ant-btn ant-btn-secondary mr-3" href="/combined-set-statistics">Thống kê giỏ gộp SET</a>
                        </div>
                    </div>
                    
                    <InputBarcode
                        ref={this.barcodeRef}
                        onClose={this._handleClose}
                        loading={loading}
                        value={barcode}
                        onChange={this._handleOnChange}
                        onSubmit={this._handleSubmit}
                    />
                    {
                        !!error &&
                        <div className="alert alert-danger">
                            <div className="Huge">
                                {/* <strong>Lỗi: </strong> */}
                                <span>{error}</span>
                            </div>
                        </div>
                    }

                    {
                        !!result &&
                        <MergerSetDetail
                            barcode={barcode}
                            result={result}
                            onClose={this._handleClose}
                            onFocusInput={this._handleFocusInput}
                            onReset={this._submitBarcode}
                        />
                    }
                </div>
            </Spin>
        )
    }
}

export default MergerSetPage
